import { loadScript } from '@/utils/helpers';

export function loadYotpoScript() {
  if (!process.env.NEXT_PUBLIC_YOTPO_APP_KEY) {
    console.warn(`Missing Yotpo app key. Can't display product reviews.`);
    return;
  }

  if (typeof window !== 'undefined' && window.yotpo) {
    window.yotpo.refreshWidgets();
  } else {
    loadScript(
      `https://staticw2.yotpo.com/${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}/widget.js`,
      'yotpo-script',
    );
  }
}
